// Admin palette and number formats. Ported from splitfin-manager
// src/components/dash/charts/{palette,formatters}.ts. Colours are the admin theme's CSS
// variables (components/admin/theme/admin-theme.css), so they follow dark and light mode;
// use them in `style`, not in SVG presentation attributes.

export const ink = {
  strong: 'var(--oa-text)',
  body: 'var(--oa-text)',
  soft: 'var(--oa-muted)',
  muted: 'var(--oa-muted)',
  line: 'var(--oa-line-2)',
  lineStrong: 'var(--oa-line-3)',
  surface: 'var(--oa-raised)',
};

export const series = {
  green: 'var(--oa-accent)',
  greenDark: 'var(--oa-accent)',
  ink: 'var(--oa-text)',
  slate: 'var(--oa-muted)',
  sky: 'var(--oa-s3)',
  amber: 'var(--oa-warn)',
  coral: 'var(--oa-bad)',
  red: 'var(--oa-bad)',
};

export const seriesOrder = [series.green, series.ink, series.sky, series.amber, series.coral, series.slate];

export type YFormat = 'int' | 'compact' | 'gbp' | 'pct';

const int = new Intl.NumberFormat('en-GB', { maximumFractionDigits: 0 });
const compactFmt = new Intl.NumberFormat('en-GB', { notation: 'compact', maximumFractionDigits: 1 });
const gbp = new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP', maximumFractionDigits: 0 });

export const yFormatters: Record<YFormat, (v: number) => string> = {
  int: (v) => int.format(v),
  compact: (v) => compactFmt.format(v),
  gbp: (v) => gbp.format(v),
  pct: (v) => `${(v * 100).toFixed(1)}%`,
};

export const shortDay = (iso: string) =>
  new Date(iso).toLocaleDateString('en-GB', { day: 'numeric', month: 'short' });

export const shortMonth = (iso: string) =>
  new Date(iso).toLocaleDateString('en-GB', { month: 'short', year: '2-digit' });

/** "3m ago", "2h ago", "5 Sep". */
export const ago = (iso: string | null | undefined) => {
  if (!iso) return '';
  const s = (Date.now() - new Date(iso).getTime()) / 1000;
  if (s < 60) return 'just now';
  if (s < 3600) return `${Math.floor(s / 60)}m ago`;
  if (s < 86400) return `${Math.floor(s / 3600)}h ago`;
  if (s < 7 * 86400) return `${Math.floor(s / 86400)}d ago`;
  return shortDay(iso);
};
